<template>
  <div class="cardess-webkit--container fg-mask">
    <main-tabs />
    <router-view/>
  </div>
</template>

<script>
import TrackingApiService from '@/services/TrackingApiService';
import MainTabs from '@/components/MainTabs';

export default {
  name: 'App',
  created () {
    TrackingApiService.trackWithFg({
      section: 'ApplicationLoaded',
      value4: location.href
    });
  },
  components: {
    MainTabs
  }
};
</script>

<style src="./style/main.scss" lang="scss">
</style>
